import { ContainerModule } from '@evertel/di'
import { ThemeState } from './ThemeState'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(ThemeState).toSelf().inSingletonScope()
    })
]

export {
    DI_MODULES
}
